import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 获取最后的消息列表
export const batchSave = async data => {
  return request(`${UrlConfig.Cache.batchSaveOrUpdateForAuth}`, {
    method: METHODS.POST,
    data,
  })
}

// 获取消息列表
export const cacheQuery = async data => {
  return request(`${UrlConfig.Cache.mapByKeysForAuth}`, {
    method: METHODS.POST,
    data,
  })
}
export const batchGetForAuth = async (option: any) => {
  return await request(UrlConfig.Cache.batchGetForAuth, {
    method: METHODS.POST,
    ...option,
  })
}

export const batchSaveOrUpdateForAuth = async (option: any) => {
  return await request(UrlConfig.Cache.batchSaveOrUpdateForAuth, {
    method: METHODS.POST,
    ...option,
  })
}
